import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import userReducer from './features/userSlice_new';
import passwordReducer from './features/passwordSlice';
import uploadReducer from './features/uploadSlice'
export const store=configureStore({
    reducer:{userReducer,passwordReducer,uploadReducer}
})
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;